import { Box, Portal } from '@chakra-ui/react';
import MenuList from '@components/common/menu/MenuList';
import {
  MapFeatureSelectionProps,
  useMapFeatureSelection,
} from '@components/map/layers/flightPlans/configuration/useMapFeatureSelection';

function MapFeatureSelectionOverlay(props: Readonly<MapFeatureSelectionProps>) {
  const { items, clickPosition } = useMapFeatureSelection(props);

  if (!items || !clickPosition) return null;

  return (
    <Portal>
      <Box position="absolute" zIndex={4} top={clickPosition.y} left={clickPosition.x}>
        <MenuList menuItems={items} />
      </Box>
    </Portal>
  );
}

export default MapFeatureSelectionOverlay;
